import styled from 'styled-components';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { useUuidBasedProject } from 'utils/hooks/useUuidBasedProject';

const UL = styled.ul`
  list-style-type: none;
  padding-top: 5px;
  padding-left: 0;
  font-size: 12px;
  li {
    padding-right: 10px;
    display: inline-block;
    a {
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    }
  }
`;

type Props = {
  /** Id of list corresponding to this toolbar */
  emailListId: number;
};

export const EditListToolbar = ({ emailListId }: Props) => {
  const { isEmailNonUnique } = useUuidBasedProject();

  const UPDATE_LINK = `/lists/update?emailListId=${emailListId}`;
  const UNSUB_LINK = `/lists/unsub?emailListId=${emailListId}`;
  const ADD_SUBSCRIBER_FORM_LINK = `/lists/addSubscriberForm?emailListId=${emailListId}`;

  return (
    <UL data-test="edit-list-toolbar">
      <li>
        <a href={UPDATE_LINK} data-test="addSubscribersLink">
          <SemanticUI.Icon name={'plus'} /> Add subscribers / Modify List
        </a>
      </li>
      <li>
        <a href={UNSUB_LINK} data-test="removeSubscribersLink">
          <SemanticUI.Icon name={'minus circle'} /> Remove subscribers
        </a>
      </li>
      {!isEmailNonUnique && (
        <li>
          <a href={ADD_SUBSCRIBER_FORM_LINK} data-test="signupFormLink">
            <SemanticUI.Icon name={'code'} /> Signup Form
          </a>
        </li>
      )}
    </UL>
  );
};
